(function () {
  'use strict';

  const published = new Set();

  function publish(name, data, onceKey) {
    if (onceKey && published.has(onceKey)) return;
    if (onceKey) published.add(onceKey);
    const payload = Object.assign({
      path: window.location.pathname,
      page_type: document.body && Array.from(document.body.classList).find(c => c.indexOf('template-') === 0) || 'unknown',
      timestamp: new Date().toISOString()
    }, data || {});
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('carrco:' + name, payload);
      }
    } catch (error) {
      if (window.console && console.debug) console.debug('[Carrco analytics]', error);
    }
  }

  function builderState() {
    try {
      const debug = window._ccDebug && window._ccDebug();
      if (!debug || !debug.state) return {};
      return {
        width: debug.state.w,
        height: debug.state.h,
        quantity: debug.state.q,
        finish: debug.state.finish
      };
    } catch (_) { return {}; }
  }

  document.addEventListener('click', function (event) {
    const target = event.target.closest('a,button');
    if (!target) return;

    if (target.matches('.cc-next__button,.cc-brand-footer__lead>a')) {
      publish('primary_cta_clicked', { label: target.textContent.trim(), destination: target.getAttribute('href') });
    }
    if (target.matches('.cc-product-tile')) {
      publish('product_tile_clicked', { product: target.querySelector('h2')?.textContent.trim(), destination: target.getAttribute('href') });
    }
    if (target.matches('.cc-qty-btn,.cc-finish-btn')) {
      window.setTimeout(function () { publish('configuration_changed', builderState()); }, 0);
    }
    if (target.matches('#cc-add-to-cart')) {
      publish('custom_order_cta_clicked', builderState());
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('#cc-w,#cc-h')) publish('configuration_changed', builderState());
  });

  const observer = new MutationObserver(function () {
    const uploaded = Array.from(document.querySelectorAll('input[name^="properties["]')).some(function (input) {
      return /^https?:\/\//.test((input.value || '').trim());
    });
    if (uploaded) publish('artwork_uploaded', builderState(), 'artwork-uploaded');
  });

  document.addEventListener('DOMContentLoaded', function () {
    publish('theme_ready', { theme_system: 'carrco-next' }, 'theme-ready');
    observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
  });
})();
